import {IOfferFromJSON} from '../../../../types';
import {
    NO_PATTERN_BUSINESS_LOGIC,
    Price,
} from '@vfde-brix/core';
import {
    OFFER_CARD_PRICE_DETAILS_BASKET_SUMMARY_MONTHLY,
    OFFER_CARD_PRICE_DETAILS_BASKET_SUMMARY_ONETIME,
} from 'Container/OfferDisplay/constant';
import {
    createBasketSummaryComponent,
    IBasketadditionalPrice,
} from '@vfde-brix/basket-summary';
import {
    IBaketSummaryLine,
    IBasketSummaryProperties,
} from '@vfde-brix/basket-summary';
import {IPromoPriceProperties} from '@vfde-brix/promo-price';

const HTMLMarkup = require('../../_html_/AccordionContent.hbs');

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

// @ToDo: remove, when PromoPrice Problem with -0 is solved
/**
 * The promoPrice component doesn't render the euro "minus" sign, in case
 * of -0 (that happens, when discount is lessthan 1 euro). To solve this
 * intermediately, we add the minus sign here
 * @param offer
 */
const minusNullEuroWorkaround = (offer: IOfferFromJSON, el: HTMLElement) => {
    const discount: Price = Price.fromString(offer.Total_Onetime_wDiscount);

    if (0 <= offer.Total_Onetime_wDiscount.indexOf('-') && 0 === discount.euro) {
        const targetSpan: HTMLElement = <HTMLElement> el.getElementsByClassName('brix-promo-price__euro')[0];
        const {textContent} = targetSpan;
        targetSpan.innerText = '-' + textContent;
    }
};

/**
 * B A S K E T - S U M M A R Y
 */
const generateBasketSummaryMonthlyFirstLine = (offer: IOfferFromJSON): IBaketSummaryLine => {

    const summaryAdditionalPrices: IBasketadditionalPrice[] = [];

    for (let i = 1; 5 > i; i++) {
        const totalSubline = offer[`Total_Subline_${i}`];
        if ('' !== totalSubline) {
            const summaryAdditionalPrice: IBasketadditionalPrice = {
                label: totalSubline,
                price: '',
            };
            summaryAdditionalPrices.push(summaryAdditionalPrice);
        }
    }

    // First line with big Price
    const summaryPrice: IPromoPriceProperties = {
        price: Price.fromString(offer.Total_wDiscount_BigPrice),
        optSizeVariation: 'small',
        optShowCentsAlways: false,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return {
        label: 'Gesamtpreis pro Monat',
        price: summaryPrice,
        additionalPrice: summaryAdditionalPrices,
    };

};

const generateBasketSummaryOnetimeFirstLine = (offer: IOfferFromJSON): IBaketSummaryLine => {

    const summaryPrice: IPromoPriceProperties = {
        price: Price.fromString(offer.Total_Onetime_wDiscount),
        optSizeVariation: 'small',
        optShowCentsAlways: false,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return {
        label: offer.Total_Onetime_wDiscount_Label,
        price: summaryPrice,
    };
};

const renderBasketSummaryMonthly = (element: HTMLElement, offer: IOfferFromJSON) => {

    const basketSummaryDIV: HTMLElement = <HTMLElement>element.getElementsByClassName(OFFER_CARD_PRICE_DETAILS_BASKET_SUMMARY_MONTHLY)[0];
    const basketSummaryLine: IBaketSummaryLine = generateBasketSummaryMonthlyFirstLine(offer);

    const basketSummaryProperties: IBasketSummaryProperties = {
        lines: [basketSummaryLine],
        legalText: '(Alle Preise inkl. 19% MwSt.)',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    createBasketSummaryComponent(basketSummaryDIV, basketSummaryProperties);

    // small adjustment of brix component
    const basketSummaryChildDIV: HTMLDivElement = <HTMLDivElement> basketSummaryDIV.firstChild;
    basketSummaryChildDIV.className = 'brix-basket-summary brix-card brix-pad-100--desktop-up brix-pad-50';

};

const renderBasketSummaryOnetime = (element: HTMLElement, offer: IOfferFromJSON) => {

    const basketSummaryDIV: HTMLElement = <HTMLElement>element.getElementsByClassName(OFFER_CARD_PRICE_DETAILS_BASKET_SUMMARY_ONETIME)[0];
    const basketSummaryLine: IBaketSummaryLine = generateBasketSummaryOnetimeFirstLine(offer);

    const basketSummaryProperties: IBasketSummaryProperties = {
        lines: [basketSummaryLine],
        legalText: '(Alle Preise inkl. 19% MwSt.)',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    createBasketSummaryComponent(basketSummaryDIV, basketSummaryProperties);

    // small adjustment of brix component
    const basketSummaryChildDIV: HTMLDivElement = <HTMLDivElement> basketSummaryDIV.firstChild;
    basketSummaryChildDIV.className = 'brix-basket-summary brix-card brix-pad-100--desktop-up brix-pad-50';

    // workaround
    minusNullEuroWorkaround(offer, basketSummaryDIV);
};

/**
 * renders the multi divider dynamically
 * @param element
 * @param offer
 */
export const renderBasketSummary = (element: HTMLElement, offer: IOfferFromJSON) => {

    renderBasketSummaryMonthly(element, offer);
    renderBasketSummaryOnetime(element, offer);

};
